import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class GhostOwnershipInfoService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveGhostOwnership(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }
    const params = _.merge({}, globalService?.globalParams || globalService || {}, {
      filing_key: data.rowData.FILING_GROUP,
      column_value: data.rowData[data.colData.map],
      column_name: data.colData.map,
      ho_leid: data.rowData.HO_LEID,
      ho_cdr_no: data.rowData.HO_CDR_NO,
      parent_leid: data.rowData.PARENT_LEID,
      parent_cdr_no: data.rowData.PARENT_CDR_NO,
      ghost_scenario: data.rowData.SCENARIO
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=pi3aff`,
      params,
      globalService,
      filterParams
    );
  }
}
